import { BONDS_STORE_NAME } from '@/creditflowresearch/application/Bonds/constants';
import OneLevelList from '@/creditflowresearch/ui/common/components/organisms/Filters/FiltersPanel/OneLevelList/OneLevelList';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';

const OneLevelListContainer = (props) => {
  const { filterName } = props;
  const { getFiltersByFilterName } = useFiltersContext();
  const filters = getFiltersByFilterName(BONDS_STORE_NAME, filterName) || [];

  return (
    <OneLevelList
      { ...props }
      filterName={ filterName }
      filters={ filters }
    />
  );
};

export default OneLevelListContainer;
